import React from 'react';
import AlertDlgContext from '../../AlertDlgContext';

const withAlert = Cmp => props => (
	<AlertDlgContext.Consumer>
		{alertProps => <Cmp {...props} {...alertProps} />}
	</AlertDlgContext.Consumer>
);
export default withAlert;
